export { PluginsDrawer } from './PluginsDrawer.component';
